import { Notices } from "@/lib/notices"

import { NoticeItemComponent } from "@/components/Notice/Item/component"

export const NoticeItemConsumer = Notices.consumeFunctions(NoticeItemComponent)
